<!--<div class="modal-header dark-header">-->
<!--  <h4 class="mb-0">Stored Filters</h4>-->
<!--  <button type="button" class="close" aria-label="Close" (click)="closeModal()">-->
<!--    <span class="font-weight-light fs-20" aria-hidden="true">&times;</span>-->
<!--  </button>-->
<!--</div>-->
<div class="modal-header dark-header">
  <h4 class="modal-title pull-left">Stored Filters</h4>
  <button type="button" class="btn-close close pull-right fs-12" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true" class="visually-hidden font-weight-light">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ul ngbNav #nav="ngbNav" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink>My Filters</a>
      <ng-template ngbNavContent>
        <div class="p-3 border border-top-0 rounded-bottom">

          <ng-container *ngIf="myFilters.length > 0; else noFilters">
            <div class="table-responsive">
              <table class="table table-bordered mb-0">
                <thead>
                <tr>
                  <th style="width: 35px">#</th>
                  <th>Filter Label</th>
                  <th style="width: 90px" class="text-center"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let selection of myFilters; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ selection.label }}</td>
                  <td class="text-center">
                    <ng-container *ngIf="sid !== selection.id; else removeFilter">
                      <button class="btn btn-outline-success" (click)="onSelect(selection.id)">
                        Apply
                      </button>
                    </ng-container>
                    <ng-template #removeFilter>
                      <button class="btn btn-outline-danger" (click)="onRemove()">
                        Clear
                      </button>
                    </ng-template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink>Shared Filters</a>
      <ng-template ngbNavContent>
        <div class="p-3 border border-top-0 rounded-bottom">

          <ng-container *ngIf="sharedFilters.length > 0; else noFilters">
            <div class="table-responsive">
              <table class="table table-bordered mb-0">
                <thead>
                <tr>
                  <th style="width: 35px">#</th>
                  <th>Filter Label</th>
                  <th style="width: 90px" class="text-center"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let selection of sharedFilters; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ selection.label }}</td>
                  <td class="text-center">
                    <ng-container *ngIf="sid !== selection.id; else removeFilter">
                      <button class="btn btn-outline-success" (click)="onSelect(selection.id)">
                        Apply
                      </button>
                    </ng-container>
                    <ng-template #removeFilter>
                      <button class="btn btn-outline-danger" (click)="onRemove()">
                        Clear
                      </button>
                    </ng-template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>

<ng-template #noFilters>
  <nz-alert nzType="info" nzMessage="No filters available!" nzCloseable="true"></nz-alert>
</ng-template>
